$(function(){
  if($(window).width() < 601) {
    $(".new_button_design .second-slider").each(function(){
      if($(this).children(".grid-items__3").length > 1) {
        $(this).flickity({
          // options
          cellAlign: 'left',
          wrapAround: true,
          draggable: false,
          pageDots: false
        });
      }
    });
  }
    
});



